export default __webpack_public_path__ + "static/media/viktor-bystrov.9bfe2b58.png";